<div class="wrapper">
    <div class="message-wrapper">
        <p class="merck-font-title">{{textConstants.ACCESS_DENIED}}</p>
        <p class="subtitle">{{textConstants.ACCESS_DENIED_SUBTITLE}}</p>
    </div>
   
</div>
